import React, { useState } from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const GlassCard: React.FC<GlassCardProps> = ({ 
  children, 
  className = '',
  hover = true
}) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!hover) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  return (
    <div
      className={`relative group rounded-2xl backdrop-blur-xl bg-white/50 dark:bg-gray-800/50 border border-white/20 dark:border-gray-700/30 overflow-hidden transition-all duration-300 ${
        hover ? 'hover:border-optibiz-blue/50 dark:hover:border-optibiz-blue/50 hover:shadow-2xl' : ''
      } ${className}`}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => {
        if (hover) setIsHovering(true);
      }}
      onMouseLeave={() => {
        if (hover) setIsHovering(false);
        setMousePosition({ x: 0, y: 0 });
      }}
    >
      {/* Gradient spotlight effect */}
      {hover && isHovering && (
        <div
          className="absolute w-40 h-40 bg-gradient-to-r from-optibiz-blue/30 to-transparent rounded-full blur-3xl pointer-events-none"
          style={{
            top: `${mousePosition.y - 80}px`,
            left: `${mousePosition.x - 80}px`,
          }}
        />
      )}
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default GlassCard;
